export const truncateString = (text, length) => {
	const rx = new RegExp("^.{" + length + "}[^ ]*");
	return rx.exec(text)[0] + '...';
}

export function generateRandomString(length) {
	const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	const charactersLength = characters.length;
	for (let i = 0; i < length; i++) {
		result += characters.charAt(Math.floor(Math.random() * charactersLength));
	}
	return result;
}